import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import Layout from "./components/Layout/Layout";
import Dashboard from "./views/Dashboard/Dashboard";
import Admin from "./views/Admin/Admin";
import {
    getUserData,
    isUserLoggedIn,
    setRequstUrl,
    getUserRBAC,
    getMileageClaimsEnabled
} from "./services/LocalStorageService";
import Events from "./views/Events/Events";
import DriverDetailsView from "./views/DriverDetails/DriverDetails";
import AnalyticsView from "./views/Analytics/Analytics";
import WallofLegendContentEngagementTab from "./views/WallofLegend-ContentEngagementTab/WallofLegendContentEngagementTab";
import ErrorAlert from "./components/ErrorAlert/ErrorAlert";
import { CrudAction, RBAC_CODE, EntityAccess, Role } from "./config/app-globals.enum";
import SearchResult from "./views/SearchResult/SearchResult";
import User from "./views/Admin/User/User";
import Group from "./views/Admin/Group/Group";
import NoAccess from "./components/NoAccess/NoAccess";
import ReportedEventDetails from './views/ReportedEventDetails/ReportedEventDetails';
import ReportedEvents from "./views/ReportedEvents/ReportedEvents";
import TableGenerate from './components/TableGenerate/TableGenerate'
import AdminReportedEventDetails from "./views/ReportedEventDetails/AdminReportedEventDetails";
import DriverLocator from './views/DriverLocator/DriverLocator';
import MileageClaims from "./views/Admin/MileageClaims/MileageClaims";
import MileageClaimDetails from "./views/Admin/MileageClaims/MileageClaimDetails";

function PrivateRoute(props) {
    //const { component: Component } = props;
    const [isLoggedIn] = useState(isUserLoggedIn(props));
    const [getRBAC] = useState(getUserRBAC(null, props));
    const [userData] = useState(getUserData);
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");

    const [alertMessage, setAlertMessage] = useState("");
    const [isAlertOpen, setIsAlertOpen] = useState(false);

    useEffect(() => {
        if (!isLoggedIn && props && props.location) {
            setRequstUrl(props.location);
        }
    }, [isLoggedIn]);

    useEffect(() => {
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
            setAlertMessage(
                "You are using an old browser, for a better experience we recommend upgrading your browser, Microsoft themselves recommend a more recent browser like Edge, and other options are available like Firefox or Chrome."
            );
            setIsAlertOpen(true);
        }
    }, []);

    const ref = React.createRef();

    return isLoggedIn ? (
        <>
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.DASHBOARD_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/(|dashboard)"
                    component={(props) => (
                        <Layout ref={ref} {...props}>
                            <Dashboard ref={ref} {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/(|dashboard)"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.DASHBOARD_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/(|dashboard/)impersonation/:impersonationid"
                    component={(props) => (
                        <Layout {...props}>
                            <Dashboard {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/(|dashboard/)impersonation/:impersonationid"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.CE_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/(engagement)"
                    component={(props) => (
                        <Layout {...props}>
                            <WallofLegendContentEngagementTab {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/(engagement)"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.CE_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/impersonation/:impersonationid/(engagement)"
                    component={(props) => (
                        <Layout {...props}>
                            <WallofLegendContentEngagementTab {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/impersonation/:impersonationid/(engagement)"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.WOL_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/(walloflegends)"
                    component={(props) => (
                        <Layout {...props}>
                            <WallofLegendContentEngagementTab {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/(walloflegends)"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.WOL_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/impersonation/:impersonationid/(walloflegends)"
                    component={(props) => (
                        <Layout {...props}>
                            <WallofLegendContentEngagementTab {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/impersonation/:impersonationid/(walloflegends)"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {/* @Todo: for now if URL is not accessible by user Type Driver, we are showing it as 404 not found page, but it should show UnAuthorise page */}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.EVENTS_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/events"
                    component={(props) => (
                        <Layout {...props}>
                            <Events {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/events"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.USER_DETAIL_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) &&
                (getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.USER_DETAIL_VIEW &&
                        item.isAccessible === EntityAccess.ALLOWED &&
                        item.isGroupScope === EntityAccess.ALLOWED
                ) ||
                    (props.computedMatch &&
                        props.computedMatch.params &&
                        props.computedMatch.params.id &&
                        userData.id === props.computedMatch.params.id)) ? (
                <Route
                    exact
                    path="/userdetails/:id"
                    component={(props) => (
                        <Layout {...props}>
                            <DriverDetailsView {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/userdetails/:id"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData ? (
                <Route
                    exact
                    path="/customtable/:tcId/:tcAction/:tcViewId?"
                    component={(props) => (
                        <TableGenerate {...props} />
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/customtable/:tcId/:tcAction/:tcViewId?"
                    component={(props) => (
                        <NoAccess />
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.USER_DETAIL_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) &&
                (getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.USER_DETAIL_VIEW &&
                        item.isAccessible === EntityAccess.ALLOWED &&
                        item.isGroupScope === EntityAccess.ALLOWED
                ) ||
                    (props.computedMatch &&
                        props.computedMatch.params &&
                        props.computedMatch.params.id &&
                        (userData.id === props.computedMatch.params.id || props.computedMatch.params.impersonationid === props.computedMatch.params.id))) ? (
                <Route
                    exact
                    path="/impersonation/:impersonationid/userdetails/:id"
                    component={(props) => (
                        <Layout {...props}>
                            <DriverDetailsView {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/impersonation/:impersonationid/userdetails/:id"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ANALYTICS_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/analytics"
                    component={(props) => (
                        <Layout {...props}>
                            <AnalyticsView {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/analytics"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ANALYTICS_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/impersonation/:impersonationid/analytics"
                    component={(props) => (
                        <Layout {...props}>
                            <AnalyticsView {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/impersonation/:impersonationid/analytics"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {/* @Todo: for now if URL is not accessible by user Type Driver, we are showing it as 404 not found page, but it should show UnAuthorise page */}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.EXPORT_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/exports"
                    component={(props) => (
                        <Layout {...props}>
                            <AnalyticsView {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/exports"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) => item.entityCode === RBAC_CODE.EXPORT_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/impersonation/:impersonationid/exports"
                    component={(props) => (
                        <Layout {...props}>
                            <AnalyticsView {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/impersonation/:impersonationid/exports"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_DASHBOARD_VIEW &&
                        item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin"
                    component={(props) => (
                        <Layout isAdminModule={true} {...props}>
                            <Admin {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_USER_CREATE_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/users"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <User userViewAction={CrudAction.ADD} {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/users"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_USER_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/users/:userId"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <User userViewAction={CrudAction.VIEW} {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/users/:userId"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_USER_EDIT_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/users/edit/:userId"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <User userViewAction={CrudAction.EDIT} {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/users/edit/:userId"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_GROUP_CREATE_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/groups/add"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <Group userViewAction={CrudAction.ADD} {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/groups/add"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_GROUP_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/groups/view/:groupId"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <Group userViewAction={CrudAction.VIEW} {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/groups/view/:groupId"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_GROUP_EDIT_VIEW && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/groups/edit/:groupId"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <Group userViewAction={CrudAction.EDIT} {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/groups/edit/:groupId"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_SEARCH_RESULT_VIEW &&
                        item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/search"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <SearchResult {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/search"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_SEARCH_RESULT_VIEW
                    // && item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/eventdetails/:userId/:eventId/:reportStatus"
                    component={(props) => (
                        <Layout {...props}>
                            <ReportedEventDetails {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/eventdetails/:userId/:eventId/:reportStatus"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_SEARCH_RESULT_VIEW &&
                        item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/eventdetails/:userId/:eventId/:reportStatus"
                    component={(props) => (
                        <Layout {...props}>
                            <AdminReportedEventDetails {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/eventdetails/:userId/:eventId/:reportStatus"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}
            {userData &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.ADMIN_SEARCH_RESULT_VIEW &&
                        item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/reported-events"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <ReportedEvents {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/reported-events"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData && getMileageClaimsEnabled() &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.MILEAGE_CLAIM &&
                        item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/admin/mileage-claims"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <MileageClaims {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/admin/mileage-claims"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {userData &&
                getMileageClaimsEnabled() &&
                getRBAC &&
                getRBAC.find(
                    (item) =>
                        item.entityCode === RBAC_CODE.MILEAGE_CLAIM &&
                        item.isAccessible === EntityAccess.ALLOWED
                ) ? (
                <Route
                    exact
                    path="/mileage-claim-details/:userId/:mileageClaimId"
                    component={(props) => (
                        <Layout isAdminModule={true} isHeaderSearch={true} {...props}>
                            <MileageClaimDetails {...props} />
                        </Layout>
                    )}
                />
            ) : (
                <Route
                    exact
                    path="/mileage-claim-details/:userId/:mileageClaimId"
                    component={(props) => (
                        <Layout {...props}>
                            <NoAccess />
                        </Layout>
                    )}
                />
            )}

            {
                userData &&
                    getRBAC &&
                    getRBAC.find(
                        (item) => item.entityCode === RBAC_CODE.LOCATOR_VIEW && item.isAccessible === EntityAccess.ALLOWED
                    ) && userData.userRoleId !== Role.DRIVER ? (
                    <Route
                        exact
                        path="/locator"
                        component={(props) => (
                            <Layout {...props} isMapScreen={true}>
                                <DriverLocator {...props} />
                            </Layout>
                        )}
                    />
                ) : (
                    <Route
                        exact
                        path="/locator"
                        component={(props) => (
                            <Layout {...props}>
                                <NoAccess />
                            </Layout>
                        )}
                    />
                )
            }
            <ErrorAlert code={200} message={alertMessage} isOpen={isAlertOpen} />
        </>
    ) : (
        <Redirect
            from="/"
            to={{
                pathname: "/login",
                state: { from: props.location },
            }}
        />
    );
}

export default PrivateRoute;
